import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { parametres } from '../shared/questionnaire.metadata';

@Injectable({
  providedIn: 'root'
})
export class ParametresService {
  private annee: BehaviorSubject<string>;
  private dateFinCampagne: BehaviorSubject<string>;
  private url: string ;
  constructor(
    private http: HttpClient,
    @Inject('API_URL') private apiUrl: string
  ) {
    this.init();

    setTimeout(() => {
      this.http.get(this.url).subscribe(params => {
        this.annee.next(params['annee']);
        parametres.annee = params['annee'];
        this.dateFinCampagne.next(params['dateFinCampagne']);
        parametres.dateFinCampagne = params['dateFinCampagne'];
      });
    }, 500);
  }

  init(): void {
    this.url = this.apiUrl + '/parametres';
    this.annee = new BehaviorSubject('');
    this.dateFinCampagne = new BehaviorSubject('');
  }

  public getAnnee$(): Observable<string> {
    return this.annee.asObservable();
  }
  public getDateFinCampagne$(): Observable<string> {
    return this.dateFinCampagne.asObservable();
  }

}
